import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
};
